import { useNavigate, useSearch } from "@tanstack/react-router"
import { useCallback, useMemo } from "react"
import type { DateRange } from "./model"
import { parseDate } from "@/utils"

export default function useDateRangeSearch() {
  const { runsFrom, runsTo } = useSearch({ strict: false })
  const navigate = useNavigate()

  const dateRange = useMemo(
    () => ({ from: parseDate(runsFrom), to: parseDate(runsTo) }),
    [runsFrom, runsTo],
  )

  const setDateRange = useCallback(
    ({ from, to }: DateRange) => {
      void navigate({
        // Without an explicit to, the search reducer's return type is never.
        to: ".",
        search: (prev) => ({
          ...prev,
          runsFrom: from?.toISOString(),
          runsTo: to?.toISOString(),
        }),
        replace: true,
      })
    },
    [navigate],
  )

  return [dateRange, setDateRange] as const
}
